import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/StoreEnums';
import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';

export interface VehicleObject {
  id: number;
  name: Array<any>;
  description: Array<any>;
  slug: string;
  isactive: boolean;
  title: string;
  modelYear: string;
  size: string;
}

export interface vehiclesListInfo {
  page: number;
  take: number;
  itemCount: number;
  pageCount: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  vehicle: Array<VehicleObject>;
  errors: unknown;
}

export interface vehiclesFilterInfo {
  vehicleName: string;
}

@Module
export default class vehicleModule
  extends VuexModule
  implements vehiclesListInfo
{
  vehicle = [] as Array<VehicleObject>;
  vehiclesFilter = {} as vehiclesFilterInfo;
  page = 1;
  take = 10;
  itemCount = 0;
  pageCount = 1;
  hasPreviousPage = false;
  hasNextPage = true;
  errors = {};

  /**
   * Get vehicle list
   * @returns Array<VehicleObject>
   */
  get vehiclesList(): Array<VehicleObject> {
    return this.vehicle;
  }

  /**
   * Get total items
   * @returns number
   */
  get vehiclesListCount(): number {
    return this.itemCount;
  }

  @Mutation
  [Mutations.SET_VEHICLES](data) {
    this.vehicle = data.data;
    this.page = data.meta.page;
    this.take = data.meta.take;
    this.itemCount = data.meta.itemCount;
    this.pageCount = data.meta.pageCount;
    this.hasPreviousPage = data.meta.hasPreviousPage;
    this.hasNextPage = data.meta.hasNextPage;
    this.errors = {};
  }

  @Mutation
  [Mutations.SET_VEHICLES_CURRENT_PAGE](page) {
    this.page = page;
  }

  @Mutation
  [Mutations.RESET_VEHICLES_LIST]() {
    this.vehicle = [] as Array<VehicleObject>;
    this.page = 1;
    this.take = 10;
    this.itemCount = 0;
    this.pageCount = 1;
    this.hasPreviousPage = false;
    this.hasNextPage = true;
    this.errors = {};
  }

  @Mutation
  [Mutations.SET_VEHICLES_FILTER](obj) {
    this.vehiclesFilter.vehicleName = obj.vehicleName;
  }

  @Action
  [Actions.RESET_VEHICLES_STORE]() {
    this.context.commit(Mutations.RESET_VEHICLES_LIST);
  }

  @Action
  [Actions.CREATE_VEHICLE](data) {
    ApiService.setAuthorizationHeader();
    return ApiService.post('/vehicle-types', data)
      .then(() => {
        this.context.commit(Mutations.RESET_VEHICLES_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.statusText],
        });
      });
  }

  @Action
  [Actions.DELETE_VEHICLE](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.delete('/vehicle-types', id)
      .then(() => {
        this.context.commit(Mutations.RESET_VEHICLES_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.statusText],
        });
      });
  }

  @Action
  [Actions.UPDATE_VEHICLES_FILTER](val) {
    this.context.commit(Mutations.SET_VEHICLES_FILTER, val);
  }

  @Action
  [Actions.UPDATE_VEHICLE]({ id, data }) {
    ApiService.setAuthorizationHeader();
    return ApiService.update('/vehicle-types', id, data)
      .then(() => {
        this.context.commit(Mutations.RESET_VEHICLES_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.statusText],
        });
      });
  }

  @Action
  [Actions.UPDATE_VEHICLE_CURRENT_PAGE](val) {
    this.context.commit(Mutations.SET_VEHICLES_CURRENT_PAGE, val);
  }

  @Action
  [Actions.GET_VEHICLE](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/vehicle-types', id);
  }

  @Action
  [Actions.GET_VEHICLES]() {
    const params = {
      page: this.page,
      vehicleName: this.vehiclesFilter.vehicleName,
    };
    ApiService.setAuthorizationHeader();
    return ApiService.query('/vehicle-types', { params })
      .then(({ data }) => {
        this.context.commit(Mutations.SET_VEHICLES, data);
      })
      .catch(({ response }) => {
        console.error(response);
        // this.context.commit(Mutations.SET_ERROR, {
        //   [response.statusText]: [response.data.statusText],
        // });
      });
  }
}
